export default {
  loading(state) {
    return state.loading;
  },
  qualifications(state) {
    return state.qualifications;
  },
  qualificationsUnresolved(state) {
    return state.qualificationsUnresolved;
  },
  isQualifing(state) {
    let list = state.qualifications.filter((el) => el.status === "pending");
    return list.length > 0;
  },
  getQualificationsIds(state) {
    const filterQualifications = state.qualifications.filter(
      (q) => q.status !== "pending",
    );
    const ids = filterQualifications.map((q) => q.id);
    return ids;
  },
};
